import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const BACK_FORM_INITIAL_VALUES = {
  sections: {
    back: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};
